



































































































































































































































































import VueOptions from '@utils/VueOptions'
import EventService from '@services/EventService'
import AuthService from '@services/AuthService'
import HubspotService from '@services/HubspotService'
import Back from '@modules/ui/buttons/Back'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import CartItems from './CartItems'
import ShoppingCartSummary from '@ui/EventFeed/ShoppingCartSummary'
import LoginForm from '@ui/PartnerBuy/LoginForm'
import SignUpForm from '@ui/PartnerBuy/SignUpForm'

import BulkEditCartModal from '@ui/Campaign/pipeline/Checkout/BulkEditCartModal'
# import RemoveEventFromCartTriggerModal from '@triggers/Campaign/RemoveEventFromCartTriggerModal'
import SubmitOffersTriggerModal from '@triggers/CheckoutWizard/SubmitOffersTriggerModal'
# import UpdateOriginalPriceTriggerModal from '@triggers/CheckoutWizard/UpdateOriginalPriceTriggerModal'
# import UpdateOriginalPayoutTriggerModal from '@triggers/CheckoutWizard/UpdateOriginalPayoutTriggerModal'
import UpdateQuantityTriggerModal from '@triggers/CheckoutWizard/UpdateQuantityTriggerModal'
import AddPurchaseDiscountTriggerModal from '@triggers/Campaign/AddPurchaseDiscountTriggerModal'
import TransferCampaignListingsTriggerModal from '@triggers/Campaign/TransferCampaignListingsTriggerModal'
import AddServicesToCartTriggerModal from '@triggers/Campaign/AddServicesToCartTriggerModal'
import ExportCartDeckTriggerModal from '@triggers/Campaign/ExportCartDeckTriggerModal'
import ClearCartTriggerModal from '@triggers/Campaign/ClearCartTriggerModal'

settings =
  name: "CampaignCheckout"

  resources:
    cart:
      resourceName: 'shopping_cart'
      slug: 'campaigns/:campaignId/shopping_cart'

    line_items:
      resourceName: 'shopping_cart_line_item'
      slug: 'campaigns/:campaignId/shopping_cart_line_items'
      infinityScroll: true

    campaign:
      resourceName: 'campaign'
      slug: 'campaigns/:campaignId'

    activation_plans:
      resourceName: 'activation_plan'
      slug: 'campaigns/:campaignId/activation_plans'
      fetch: false

  vue:
    props: ['campaignId', 'resourceSlug']
    components: {
      Back,
      Modal,
      RequestButton,
      CartItems,
      ShoppingCartSummary,
      LoginForm,
      SignUpForm,

      BulkEditCartModal,
      # RemoveEventFromCartTriggerModal,
      SubmitOffersTriggerModal,
      # UpdateOriginalPriceTriggerModal,
      # UpdateOriginalPayoutTriggerModal,
      UpdateQuantityTriggerModal,
      AddPurchaseDiscountTriggerModal,
      TransferCampaignListingsTriggerModal,
      AddServicesToCartTriggerModal,
      ExportCartDeckTriggerModal,
      ClearCartTriggerModal,
    }

    data: ->
      agreeToTOS: false
      agreeToOrganizerTOS: false

      bulkEditCartModal:
        show: false
      purchaseProgressModal:
        show: false

      error: null
      isLoading: false

      loginData:
        email: ''
        password: ''

      signUpData:
        social_presence:
          market_type: 'buyer'
          email: ''
          password: ''
          password_confirmation: ''
          first_name: null
          last_name: null
          role: null
          title: null
        top_org:
          organization_type: 'brand'
          organization_name: null
          uniqid: null
        tos:
          sponsor_terms_of_service: accepted: true

    created: ->
      @registerEventHandlers()

    mounted: ->
      if @brandRep
        @loginData.email = @brandRep.email
        @signUpData.social_presence.email = @brandRep.email

    beforeDestroy: ->
      @unregisterEventHandlers()

    computed:
      member: -> @currentMember()
      cartIsEmpty: -> !@line_items?.length
      canPurchaseSharedCampaign: -> 
        return true if @currentMemberIsSuperUser()
        @ctxOwner(@campaign).id is @brandRep.id

      canPurchase: ->
        progressBars = @getAppSession('progress_bars', [])
        eventsBeingAdded = !!progressBars.find((bar) -> bar.key.includes('add_target_events'))
        eventsBeingRefreshed = !!progressBars.find((bar) -> bar.key.includes('refresh_cart'))

        return false if @cart.purchase_in_progress
        return false if @cart.additional_terms_required and !@agreeToOrganizerTOS
        @agreeToTOS and !@cartIsEmpty and !eventsBeingAdded and !eventsBeingRefreshed

      eventOwner: ->
        if @oneOwner
          supplier = @line_items?[0]?.ctx?.supplier?.org?.name
          return supplier if supplier
        "Organizers"

      hasHave: ->
        return "has" if @oneOwner
        "have"

      oneOwner: -> 
        @campaign?.target['audience_partnership_token']

      partnerBuy: -> @getAppSession 'partnerBuy'
      brandRep: -> @$store.member?.brand_rep || @partnerBuy?.brandRep
      displayLoginForm: -> !!@brandRep?.member_id

      isLoginSignupFormValid: ->
        if @displayLoginForm
          pwd = @loginData.password.trim()
          return pwd.length > 0
        else
          pwd = @signUpData.social_presence.password.trim()
          pwd_confirmation = @signUpData.social_presence.password_confirmation.trim()
          return pwd.length > 0 and pwd is pwd_confirmation
        false

      enableCompleteBooking: ->
        @canPurchase and @isLoginSignupFormValid

      cartActions: ->
        {
          @fetchResource
          @removeAudienceListingFromCartTrigger
          @removeVendorListingFromCartTrigger
          @hiSaveForLaterTrigger
          @hiMoveToCartTrigger
          @refreshCartListingTrigger,
          @refreshCartTrigger,
          @transferCampaignListingsTrigger,
          @updateOriginalPriceTrigger
          @updateOriginalPayoutTrigger
          @updateQuantityTrigger
          @updateLineItemDiscountTrigger
          @hiRemovePurchaseDiscountTrigger,
          @clearCartTrigger,
          @hiEditLineItemsForEvent,
          @favoriteEventTrigger,
          @unfavoriteEventTrigger,
          @editVendorListing,
        }

    methods:
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

      registerEventHandlers: ->
        @unregisterEventHandlers()
        EventService.$on('progress-bar-completed', @onProgressBarCompleted);
      unregisterEventHandlers: ->
        EventService.$off('progress-bar-completed', @onProgressBarCompleted)
      onProgressBarCompleted: (bar) ->
        options = ['add_target_events', 'transfer_campaign_listings', 'refresh_cart', 'bulk_add_listings']
        keys = bar.key.split('.')
        action = keys[keys.length - 1]
        @fetch('cart') if options.includes action

      hiPurchaseTrigger: ->
        payload = {}
        @triggerResource 'cart', 'purchase', payload
        @purchaseProgressModal.show = true
      onCartPurchase: ->
        @fetch('cart')
        @fetchProgressBars()

      hiPurchaseDone: ->
        @purchaseProgressModal.show = false
        @$router.push({ name: 'CampaignScheduleStage', query: { purchased: 'success' } })

      hiCompleteBooking: ->
        if @displayLoginForm
          @login()
        else
          @register()

      login: ->
        @error = null
        @isLoading = true
        try
          member = await AuthService.login @loginData
          @setCurrentMember member
          @redirectToPurchase()
        catch errors
          @error = errors.error
        finally
          @isLoading = false

      register: ->
        @error = null
        @isLoading = true
        try
          member = await AuthService.register @signUpData
          HubspotService.submitHubspotForm @signUpData.social_presence.email, @$route
          @setCurrentMember member
          @redirectToPurchase()
        catch error
          @error = error
        finally
          @isLoading = false

      redirectToPurchase: ->
        { campaignId } = @$route.params
        window.location.href = "/campaigns/#{campaignId}/checkout?purchase=true"

      tryAutoPurchase: ->
        { purchase, ...query } = @$route.query
        return unless purchase
        return if @cartIsEmpty
        @$router.replace { query }
        @hiPurchaseTrigger()

      removeAudienceListingFromCartTrigger: (audienceListing, segment) ->
        @triggerResource 'line_items', 'remove_listing_from_cart', { audience_listing_id: audienceListing.id, segment }
      removeVendorListingFromCartTrigger: (vendorListing) ->
        @triggerResource 'line_items', 'remove_listing_from_cart', { vendor_listing_id: vendorListing.id }
      onLineItemsRemoveListingFromCart: ->
        @fetch 'cart'

      refreshCartListingTrigger: (lineItem, listing, segment) ->
        @triggerResource 'line_items', 'refresh_listing', { line_item_id: lineItem.id, listing_id: listing.id, segment }
      onLineItemsRefreshListing: (data, newLineItem) ->
        oldLineItem = @line_items.find((lineItem) -> lineItem.id is data.line_item_id)
        @onUnloadItem 'line_items', { item: oldLineItem }
        @fetchActivationPlansFor [newLineItem]
        @fetch 'cart'

      refreshCartTrigger: ->
        @triggerResource 'line_items', 'refresh_cart'
      onLineItemsRefreshCart: ->
        @fetch 'cart'
        @fetchProgressBars()

      transferCampaignListingsTrigger: ->
        payloadOptions = {}
        modalOptions = { campaign: @campaign }
        @$refs.transferCampaignListingsTrigger.fire(payloadOptions, modalOptions)
      onCampaignTransferCampaignListings: (data, response) ->
        @fetchProgressBars()
        @$refs.transferCampaignListingsTrigger.close()
        @$router.push({ name: "CampaignCheckoutStage", params: {campaignId: response.to_campaign_id} })
        @showFlash({ Info: 'Your listings were being transferred. Please refresh in a minute.' })
        @fetch('cart')
        window.location.reload()

      clearCartTrigger: ->
        payloadOptions = { campaign_id: @campaign.id }
        @$refs.clearCartTrigger.fire(payloadOptions)
      onCartClearCart: ->
        @$refs.clearCartTrigger.close()
        @clearDataForResourceKey 'line_items'
        @fetch('cart')

      hiSaveForLaterTrigger: (lineItem) ->
        payloadOptions =
          event_id: @ctxEvent(lineItem).id
        @triggerResource 'cart', 'save_for_later', payloadOptions
      onCartSaveForLater: ->
        @fetch('cart')

      hiMoveToCartTrigger: (lineItem) ->
        payloadOptions =
          event_id: @ctxEvent(lineItem).id
        @triggerResource 'cart', 'move_to_cart', payloadOptions
      onCartMoveToCart: ->
        @fetch('cart')

      submitOffersTrigger: ->
        payloadOptions =
          offer_ids: @draftOffers.map((o) -> o.id)
        @$refs.submitOffersTrigger.fire(payloadOptions)
      onDraftOffersSubmitOffers: ->
        @fetch('draftOffers')
        @$refs.submitOffersTrigger.close()

        if @currentMemberIsSuperUser()
          @$router.back()
        else
          @$router.push({ name: 'EventScheduleListPage' })

      updateOriginalPriceTrigger: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateOriginalPriceTrigger.fire(payloadOptions, modalOptions)
      onCartUpdateOriginalPrice: ->
        @fetch('cart')
        @$refs.updateOriginalPriceTrigger.close()

      updateOriginalPayoutTrigger: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateOriginalPayoutTrigger.fire(payloadOptions, modalOptions)
      onCartUpdateOriginalPayout: ->
        @fetch('cart')
        @$refs.updateOriginalPayoutTrigger.close()

      updateQuantityTrigger: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateQuantityTrigger.fire(payloadOptions, modalOptions)
      onCartUpdateQuantity: ->
        @fetch('cart')
        @$refs.updateQuantityTrigger.close()

      updateLineItemDiscountTrigger: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateLineItemDiscountTrigger.fire(payloadOptions, modalOptions)
      onCartUpdateLineItemDiscount: ->
        @fetch('cart')
        @$refs.updateLineItemDiscountTrigger.close()

      hiBulkEditCart: ->
        @bulkEditCartModal.show = true

      hiRemovePurchaseDiscountTrigger: (lineItem) ->
        payload =
          line_item_id: lineItem.id
        @triggerResource 'cart', 'remove_purchase_discount', payload
      onCartRemovePurchaseDiscount: ->
        @fetch('cart')

      hiDownload: ->
        return unless @currentMemberIsSuperUser()
        @triggerResource 'cart', 'download', {}
      onCartDownload: ->

      hiDownloadClient: ->
        return unless @currentMemberIsSuperUser()
        @triggerResource 'cart', 'download_client', {}
      onCartDownload: ->

      hiAddPurchaseDiscountTrigger: ->
        return unless @currentMemberIsSuperUser()
        @$refs.addPurchaseDiscountTrigger.fire()
      onCartAddPurchaseDiscount: ->
        @fetch('cart')
        @$refs.addPurchaseDiscountTrigger.close()

      hiAddServicesToCart: ->
        @$refs.addServicesToCartTrigger.fire()
      onLineItemsAddServiceToCart: (payload) ->
        { vendor_listing_id: vendorListingId } = payload
        @fetchProgressBars()
        @$refs.addServicesToCartTrigger.close()
        @$router.push { name: 'CampaignCheckoutVendorListingEdit', params: { vendorListingId } }

      editVendorListing: (vendorListing) ->
        @$router.push { name: 'CampaignCheckoutVendorListingEdit', params: { vendorListingId: vendorListing.id } }

      hiExportCartDeck: ->
        @$refs.exportCartDeckTrigger.fire()
      onCartExportCartDeck: ->
        @fetchProgressBars()
        @$refs.exportCartDeckTrigger.close()

      hiEditLineItemsForEvent: (event) ->
        @$router.push({ name: 'CampaignCheckoutEventEdit', params: {
            campaignId: @$route.params.campaignId,
            eventId: event.id
          }
        })

      favoriteEventTrigger: (event) ->
        @triggerResource 'campaign', 'favorite_event', { event_id: event.id }
      unfavoriteEventTrigger: (event) ->
        @triggerResource 'campaign', 'unfavorite_event', { event_id: event.id }

      fetchActivationPlansFor: (lineItems) ->
        return if @cartIsEmpty
        audienceListingIds = @uniq(@audienceListingsFor(lineItems)).map((listing) -> listing.id)
        vendorListingIds = @uniq(@vendorListingsFor(lineItems)).map((listing) -> listing.id)

        for chunk, idx in @chunkArray(audienceListingIds, 20)
          payload =
            audience_listing_ids: chunk
            vendor_listing_ids: vendorListingIds # if idx is 0
            shopping_cart_id: @cart.id

          @fetch 'activation_plans', payload

      audienceListingsFor: (lineItems=[]) ->
        listings = []
        listings.push @ctxAudienceListing(lineItem) for lineItem in lineItems when @ctxAudienceListing(lineItem)?.id?
        listings

      vendorListingsFor: (lineItems=[]) ->
        listings = []
        listings.push @ctxVendorListing(lineItem) for lineItem in lineItems when @ctxVendorListing(lineItem)?.id?
        listings

    watch:
      line_items: (newValue, oldValue) ->
        return unless newValue
        start = 0
        start = oldValue.length if oldValue
        end = newValue.length

        lineItems = newValue.slice start, end
        @fetchActivationPlansFor lineItems

      cart: ->
        @tryAutoPurchase()

export default VueOptions.vue settings
